export enum FeatureToggle {
  HPP_STRENSIQ = "hpp-strensiq",
  HPP_STRENSIQ_REDIRECT = "hpp-strensiq-redirect",
  ASTHMA = "asthma",
  LIVER_TRANSPLANT = "liver-transplant",

  DISABLE_LETTER_ISSUE_EMAILS = "disable-letter-issue-emails",

  EMAIL_INSURER = "email-insurer",

  MY_APPEALS_MODULAR_DESIGN = "my-appeals-modular-design",

  CLAUDE_OPUS_LETTER_GENERATION = "claude-opus-letter-generation",

  INSURANCE_CARD_OCR = "insurance-card-ocr",
  CAMERA_CAPTURE = "camera-capture",

  ADDRESS_AUTOCOMPLETE = "address-autocomplete",
}
